
import { defineComponent } from 'vue'
import Draggable from 'vuedraggable'

import RepoDetailMixin from '~/mixins/repoDetailMixin'
import WidgetMixin from '~/mixins/widgetMixin'

import { WIDGET_ICON_MAP } from '~/utils/repository'

export default defineComponent({
  name: 'CustomizeWidgetsModal',
  components: {
    Draggable
  },
  mixins: [RepoDetailMixin, WidgetMixin],
  data() {
    return {
      enabledWidgets: [] as string[],
      dragging: false,
      savingPreferences: false,
      searchCandidate: '',
      WIDGET_ICON_MAP,
      MAX_WIDGETS_COUNT: 6
    }
  },
  async fetch() {
    await this.fetchWidgets(this.baseRouteParams)
    this.syncWidgets()
  },
  mounted() {
    this.syncWidgets()
  },
  methods: {
    syncWidgets() {
      if (this.repository?.widgets?.length) {
        this.enabledWidgets = [...this.repository.widgets] as string[]
      }
    },
    async savePreferences(close: () => Promise<void>) {
      this.savingPreferences = true
      try {
        await this.updateRepoWidgets({
          repositoryId: this.repository.id,
          widgetCodes: this.enabledWidgets
        })
        await this.fetchWidgets({
          ...this.baseRouteParams,
          refetch: true
        })
        close()
        this.$emit('close')
      } catch (e) {
        this.$toast.danger((e as Error).message.replace('GraphQL error: ', ''))
      } finally {
        this.savingPreferences = false
      }
    }
  },
  computed: {
    availableWidgets(): string[] {
      return Object.keys(this.repository.allWidgets)
        .filter((widgetName) => !this.enabledWidgets.includes(widgetName))
        .sort()
    },
    searchResults(): string[] {
      return Object.keys(this.repository.allWidgets).filter((widget: string) => {
        return this.repository.allWidgets[widget].title
          .toLowerCase()
          .includes(this.searchCandidate.toLowerCase())
      })
    },
    enabledWidgetsSearchResults(): string[] {
      if (this.searchCandidate) {
        return this.enabledWidgets.filter((widgetName) => this.searchResults.includes(widgetName))
      }
      return this.enabledWidgets
    },
    availableWidgetsSearchResults(): string[] {
      if (this.searchCandidate) {
        return this.availableWidgets.filter((widgetName) => this.searchResults.includes(widgetName))
      }
      return this.availableWidgets
    },
    remainingCount() {
      return this.MAX_WIDGETS_COUNT - this.enabledWidgets.length
    },
    searchResultIsEmpty() {
      return (
        this.enabledWidgetsSearchResults.length === 0 &&
        this.availableWidgetsSearchResults.length === 0
      )
    },
    showWarning() {
      return this.enabledWidgets.length < this.MAX_WIDGETS_COUNT && !this.searchResultIsEmpty
    }
  }
})
